import Snackbar from "@mui/joy/Snackbar";

export interface SnackbarNotificationProps {
  readonly text: string;
  readonly color?: "primary" | "neutral" | "danger" | "success" | "warning";
  readonly onClose?: () => void;
}

export default function SnackbarNotification({ text, color, onClose }: SnackbarNotificationProps) {
  return (
    <Snackbar
      open={true}
      autoHideDuration={4000}
      variant="plain"
      size="md"
      color={color}
      onClose={onClose}
    >
      {text}
    </Snackbar>
  );
}
